import {
    combineReducers
} from 'redux';

import root from './application';
const rootReducer = combineReducers({
    root
});
export default rootReducer;